import React from 'react';
import { useUI } from 'contexts/UIContext';
import { cn } from 'lib/utils';

export const Toast: React.FC = () => {
  const { toast, hideToast } = useUI();

  if (!toast) return null;

  const variants = {
    success: 'bg-green-500 text-white',
    error: 'bg-destructive text-white',
    info: 'bg-primary text-white',
  };

  return (
    <div
      className={cn(
        'fixed top-4 right-4 z-50 flex items-center space-x-3 px-4 py-3 rounded-lg shadow-lg transition-all duration-300',
        variants[toast.type]
      )}
    >
      <span className="text-sm font-medium">{toast.message}</span>
      <button
        onClick={hideToast}
        className="text-white/80 hover:text-white ml-3"
      >
        ×
      </button>
    </div>
  );
};